import MyInput from '../../../components/ui/MyInput';
import { useEffect, useState } from 'react';
import PrimaryButton from '../../../components/ui/PrimaryButton';
import {
    SVG_Add_Square_Bold,
    SVG_Traffic_Bold,
    SVG_Trash_Bin_2_Bold,
    SVG_Trash_Bin_2_Linear,
    SVG_Trash_Bin_2_Outline,
    SVG_Trash_Bin_Minimalistic_2_Bold,
} from '@dev-mobligo/iconpack';
import { useDispatch } from 'react-redux';
import systemSlice from '../../../redux/systemSlice';
import LayeredDashboardHeader from '../../LayeredDashboardHeader';
import { useNavigate } from 'react-router-dom';
import allTabs from '../../DashboardTabs';
import CreateAction from '../../../components/operational/createAction';
import useCustomNavigate from '../../../components/operational/goBack';

import ikasLogo from '../../../assets/img/ikas.png';
import shopier from '../../../assets/img/shopier.png';
import shopify from '../../../assets/img/shopify.png';
import wix from '../../../assets/img/wix.png';
import ticimax from '../../../assets/img/ticimax.png';
import tSoft from '../../../assets/img/tsoft.png';
import ideasoft from '../../../assets/img/ideasoft.jpg';
import wooCommerce from '../../../assets/img/woocommerce.png';
import Webview from '../../../assets/img/webview.png';
import Card from '../../ChooseAppPage/OnBoarding/Card';
import FileUploader from '../../../components/ui/FileUploader';
import { JSONValidator } from '../../../helper/Validators';

const IntegrationsProvider = ({ tab }) => {

    const [selectedProvider, setSelectedProvider] = useState("IKAS")
    const [client_id, setClient_id] = useState("")
    const [client_secret, setClient_secret] = useState("")

    const navigate = useNavigate();
    const goBack = useCustomNavigate(tab);
    const getClientData = async () => {
        const response = await CreateAction({
            method: 'get',
            path: `/integrations/provider`,
            showPreLoader: true,
            isFileUploading: false,
        });

        if (response?.error) {
            return navigate('/dashboard/');
        }
        const resultData = response?.result?.resultData

        setClient_id(resultData?.providerData?.client_id || "")
        setClient_secret(resultData?.providerData?.client_secret || "")

    };
    const saveClientData = async () => {
        const response = await CreateAction({
            method: 'patch',
            path: `/integrations/provider`,
            showPreLoader: true,
            isFileUploading: false,
            data: { providerData: { client_id, client_secret }, provider: selectedProvider },
            isCreateNewApp: { duration: 2000, animationText: "Entegrasyon Ayarlarınız Yapılıyor" }
        });
        if (response.error) return;
        window.location.href = "/dashboard"
    };


    useEffect(() => {
        getClientData();
    }, []);


    return (
        <>
            <LayeredDashboardHeader tab={tab} onSave={saveClientData}></LayeredDashboardHeader>
            <div className="w-full h-[calc(100dvh-70px)] overflow-auto scrollbar-y-visible">
                <div>
                    <div className="p-[20px] flex items-center justify-center 2xl:p-[40px] flex-col max-w-[1120px] mx-auto gap-[20px]">
                        <div className="bg-white p-[20px] rounded-[10px] 2xl:p-[40px] max-w-[1120px] w-[100%]" >
                            <div className='flex flex-col gap-[20px]'>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="text-[#5E5873] text-[18px] font-semibold">Altyapı Entegrasyonu</div>
                                </div>

                                <div className="mt-[40px]">
                                    <div className="flex flex-row gap-[15px] flex-wrap">
                                        <Card setSelectedProvider={setSelectedProvider} cardImg={ikasLogo} cardName={'IKAS'} isSelected={selectedProvider === "IKAS"}></Card>
                                        <Card isDisabled={true} setSelectedProvider={setSelectedProvider} cardImg={shopier} cardName={'shopier'} isSelected={false}></Card>
                                        <Card isDisabled={true} setSelectedProvider={setSelectedProvider} cardImg={shopify} cardName={'shopify'} isSelected={false}></Card>
                                        <Card isDisabled={true} setSelectedProvider={setSelectedProvider} cardImg={ticimax} cardName={'ticimax'} isSelected={false}></Card>
                                        <Card isDisabled={true} setSelectedProvider={setSelectedProvider} cardImg={tSoft} cardName={'tSoft'} isSelected={false}></Card>
                                        <Card isDisabled={true} setSelectedProvider={setSelectedProvider} cardImg={wooCommerce} cardName={'wooCommerce'} isSelected={false}></Card>
                                    </div>
                                </div>
                                <div className='flex flex-row gap-[15px]'>
                                    <MyInput value={client_id} onChange={(e) => setClient_id(e)} label={"client_id"} placeholder='client_id' ></MyInput>
                                    <MyInput value={client_secret} onChange={(e) => setClient_secret(e)} label={"client_secret"} placeholder='client_secret' ></MyInput>
                                </div>
                            </div>
                        </div>



                    </div>
                </div>
            </div>
        </>
    );
};

export default IntegrationsProvider;
